import get from 'lodash/get';
import {
  TFilteredFrontendConfigurationItems,
  TFrontendConfigurationItem,
} from 'entries/common/widgets/context';
import { InputModes } from 'pages/common/consts/frontend-configuration';
import { TGoodsFields } from './types';

export const appendFields = ({
  fields,
  append,
  value,
}: {
  fields: number;
  append: (value: { width: string; height: string }) => void;
  value: { width: string; height: string };
}) => {
  if (fields) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < fields; i++) {
      append(value);
    }
  }
};

export const applyDoorsWindowsFields = (goodsFields: TGoodsFields, isAreaEnabled: boolean) => {
  Object.keys(goodsFields).forEach(fieldName => {
    if (!isAreaEnabled) {
      if (goodsFields[fieldName].isDecreased) {
        goodsFields[fieldName].remove();
        appendFields({
          fields: Number(get(goodsFields, `${fieldName}.count`)),
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          append: get(goodsFields, `${fieldName}.append`),
          value: { width: '', height: '' },
        });
      } else if (goodsFields[fieldName].isIncreased) {
        const count =
          Number(get(goodsFields, `${fieldName}.count`)) -
          Number(get(goodsFields, `${fieldName}.fieldsLength`));
        appendFields({
          fields: count,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          append: get(goodsFields, `${fieldName}.append`),
          value: { width: '', height: '' },
        });
      }
    }
  });
};

export const getDoorsWindowsAreaText = (isAreaEnabled: boolean): string =>
  isAreaEnabled ? 'Указать количество' : 'Указать размеры';

export const getFrontendConfigurationInputTypes = (
  frontendConfiguration: TFrontendConfigurationItem[] | null
): TFilteredFrontendConfigurationItems => {
  const frontendConfigurationInputs: TFrontendConfigurationItem[] = [];
  const frontendConfigurationCheckboxes: TFrontendConfigurationItem[] = [];
  const frontendConfigurationRestricted: TFrontendConfigurationItem[] = [];

  frontendConfiguration?.forEach(el => {
    switch (el.inputMode) {
      case InputModes.FREE: {
        frontendConfigurationInputs.push(el);
        break;
      }
      case InputModes.CHECKBOX: {
        frontendConfigurationCheckboxes.push(el);
        break;
      }
      case InputModes.RESTRICTED: {
        if (el?.options?.length) {
          frontendConfigurationRestricted.push(el);
        }
        break;
      }
    }
  });

  return {
    [InputModes.FREE]: frontendConfigurationInputs,
    [InputModes.CHECKBOX]: frontendConfigurationCheckboxes,
    [InputModes.RESTRICTED]: frontendConfigurationRestricted,
  };
};
